import { Alert, Box, Button, CircularProgress, Container, Paper, Step, StepLabel, Stepper, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router";
import { LoadState, LoadStateInfo } from "../../../redux/common";

export interface ObjectInsUpdStep {
    name: string;
    component: React.ReactNode;
    check?: () => boolean;
}

export interface ObjectInsUpdProps {
    name: string;
    submit: () => void;
    backTo: string | (() => void);
    backCleanup?: () => void;
    state: LoadStateInfo;
    steps: ObjectInsUpdStep[];
    edit: boolean;
}
const ObjectInsUpd = ({ name, submit, backTo, backCleanup, state, steps, edit }: ObjectInsUpdProps) => {
    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate();
  
    const stepDisabled = () => {
        const check = steps[activeStep].check;
        if(check && !check())
            return true;
        return false;
    };
    const handleNext = () => { if(! stepDisabled()) setActiveStep(activeStep + 1); };
    const handleBack = () => { setActiveStep(activeStep - 1); };
    const handleCancel = () => {
        if(backCleanup)
            backCleanup();
        if(typeof backTo === "function")
            backTo();
        else
            navigate(backTo);
    };
    const handleSubmit = () => {
        setActiveStep(activeStep + 1);
        submit();
    };
    
    let content = <></>;
    if(activeStep >= steps.length) {
        switch (state.state) {
          case LoadState.NotStarted:
          case LoadState.Loading:
            content = <Fragment>
                    <Typography variant="h5" gutterBottom> {edit ? "Atualizando" : "Cadastrando"} {name} </Typography>
                    <CircularProgress size={20}/>
                </Fragment>;
            break;
          case LoadState.Failed:
            content = <Box>
                    <Alert severity="error" variant='filled' sx={{ p: 1, m: 1 }}>
                        <Typography variant="body1" gutterBottom> Erro ao {edit?"editar":"criar"} {name} </Typography>
                    </Alert>
                    <Button variant="contained" onClick={() => setActiveStep(steps.length-1)} sx={{ mt: 3, ml: 1 }} > Voltar </Button>
                    <Button variant="contained" onClick={handleSubmit} sx={{ mt: 3, ml: 1 }} > Tentar novamente </Button>
                </Box>;
            break;
          case LoadState.Loaded:
                content = <Box>
                    <Alert severity="success" variant='filled' sx={{ p: 1, m: 1 }}>
                        <Typography variant="h5" gutterBottom> {edit?"Editado":"Criado"} com sucesso </Typography>
                    </Alert>
                    <Button variant="contained" onClick={handleCancel} sx={{ mt: 3, ml: 1 }} > Voltar </Button>
                </Box>;
            break;
        }
    } else {
        content = <Fragment>
            {steps[activeStep].component}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={handleCancel} variant='contained' color='error' sx={{ mt: 3, ml: 1 }}> Cancelar </Button>
                {activeStep !== 0 && (
                    <Button onClick={handleBack} variant='contained' color='info' sx={{ mt: 3, ml: 1 }}> Voltar </Button>
                )}
                { steps.length-1 === activeStep
                    ? <Button variant="contained" onClick={handleSubmit} sx={{ mt: 3, ml: 1 }} > Confirmar </Button>
                    : <Button variant="contained" disabled={stepDisabled()} onClick={handleNext} sx={{ mt: 3, ml: 1 }} > Próximo </Button>
                }
            </Box>
        </Fragment>;
    }
    
    return <Container id="insupd-container" component="main" maxWidth="sm" sx={{ mb: 4 }}>
            <Box sx={{ minWidth: "600px", maxWidth: "800px" }}>
                <Paper variant="outlined" sx={{ my: { xs: 1, md: 3 }, p: { xs: 2, md: 3 } }}>
                    <Typography component="h1" variant="h4" align="center"> {edit? "Editar" : "Criar"} {name} </Typography>
                    <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
                        { steps.map((step) => ( <Step key={step.name}> <StepLabel>{step.name}</StepLabel> </Step> )) }
                    </Stepper>
                    {content}
                </Paper>
            </Box>
        </Container>
    ;
};

export default ObjectInsUpd;